import { render, staticRenderFns } from "./menu.vue?vue&type=template&id=39a22061&scoped=true&"
import script from "./menu.vue?vue&type=script&lang=js&"
export * from "./menu.vue?vue&type=script&lang=js&"
import style0 from "./menu.vue?vue&type=style&index=0&id=39a22061&lang=scss&scoped=true&"
import style1 from "./menu.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39a22061",
  null
  
)

component.options.__file = "menu.vue"
export default component.exports